import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';

export const giftShowAnimation = ({ index }) => {
  const domElementsRef = useRef({
    id: null,
    item: null,
    img: null,
    title: null,
  });

  useEffect(() => {
    gsap.globalTimeline.resume();

    const { id, item, img, title } = domElementsRef.current;

    const showTimeline = gsap.timeline({ delay: index * 0.1 });

    showTimeline
      .set(item, { scaleX: 0, scaleY: 0, opacity: 1 })
      .to(item, { scaleX: 1, scaleY: 0.05, duration: 0.3 })
      .to(item, { scaleX: 1, scaleY: 1, duration: 0.3 })
      .from(img, { transform: 'scale(.3)', opacity: 0, duration: 0.3, ease: 'elastic.out(1, 0.5)' })
      .from([title, id].filter(Boolean), {
        delay: (i) => i * 0.3,
        transform: 'translate(-50%, 0) scale(0.3)',
        opacity: 0,
        duration: 0.3,
        ease: 'elastic.out(1, 0.5)',
      });

    return () => showTimeline?.kill?.();
  }, [index]);

  return domElementsRef;
};
